import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslate } from '@hooks';
import { deleteNetworkUser } from '@actions';
import {
  Date,
  Table,
  ButtonFlat,
  ImageCircle,
  FlexContainer,
  NetworkUserStatusBadge,
  NetworkUserFormModal,
  Text,
} from '@dotone/react-ui-core';
import NetworkUserForm from './NetworkUserForm';

const formatActions = ({ row, handleDelete }) => {
  return (
    <FlexContainer align="center" justify="center">
      <NetworkUserFormModal
        networkUser={row}
        form={<NetworkUserForm defaultValues={row} />}
        buttonProps={{ color: 'link', variant: 'edit' }}
      />
      <ButtonFlat confirm variant="delete" color="danger" onClick={() => handleDelete(row)} />
    </FlexContainer>
  );
};

const formatUser = (row) => (
  <FlexContainer column align="center">
    <ImageCircle className="mb-1" avatar src={row.avatarCdnUrl} width={75} />
    <Text className="mb-1">{row.name}</Text>
    <Text>{row.email}</Text>
  </FlexContainer>
);

const formatDate = (cell) => (cell ? <Date utc value={cell} /> : null);

const getColumns = ({ t, handleDelete }) => [
  {
    dataField: 'name',
    text: t('common:model.user'),
    headerAlign: 'center',
    headerClasses: 'w-auto',
    // hidden: true,
    formatter: (cell, row) => formatUser(row),
  },
  {
    dataField: 'status',
    text: t('status'),
    formatter: (cell) => <NetworkUserStatusBadge block value={cell} />,
  },
  {
    dataField: 'lastRequestAt',
    text: t('lastRequestAt'),
    formatter: formatDate,
  },
  {
    dataField: 'actions',
    text: '',
    isDummyField: true,
    formatter: (cell, row) => formatActions({ row, handleDelete }),
  },
];

const NetworkUserTable = (props) => {
  const { t } = useTranslate('networkUser', 'model');
  const dispatch = useDispatch();

  const handleDelete = (row) => {
    dispatch(deleteNetworkUser(row.id));
  };

  const columns = getColumns({ t, handleDelete });
  const tableProps = {
    remote: true,
    responsive: true,
    condensed: true,
    hover: true,
    classes: 'text-sm stylish-table',
    keyField: 'id',
    columns,
    ...props,
  };

  return <Table {...tableProps} />;
};

export default NetworkUserTable;
